
export const customerOrdersQuery = /* GraphQL */ `#graphql
  query getCustomerOrders($first: Int!, $after: String) {
    customer {
      orders(first: $first, after: $after, reverse: true) {
        edges {
          cursor
          node {
            id
            name              # e.g. “#1001”
            number
            processedAt
            financialStatus
            fulfillmentStatus
            totalPrice { amount currencyCode }
            lineItems(first: 5) {
              edges {
                node {
                  id
                  title
                  quantity
                  image { url altText width height }
                  variantTitle
                }
              }
            }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  }
`;
